<script lang="ts">
  import { onMount } from "svelte";
  import { userStore } from "../services/stores/user-store.js";
  import ProjectGrid from "../components/content/project/ProjectGrid.svelte";
  import CustomerHome from "../components/content/customer/CustomerHome.svelte";
  import OHUserHome from "../components/content/general/Welcome.svelte";

  let userType: string;
  let customerCode: string;
  let customerName: string;
  let customerId: string;
  let loading = true;

  // Subscribe to the userStore
  userStore.subscribe((value) => {
    if (value) {
      userType = value.user?.user_type || "";
      // For customer users, get the code from their first (and only) customer record
      if (userType === "customer" && value.user?.customers && value.user.customers.length > 0) {
        customerCode = value.user.customers[0].code;
        customerName = value.user.customers[0].name;
        customerId = value.user.customers[0].customer_id;
      }
    }
    loading = false;
  });

  onMount(async () => {});
</script>

<div class="app-grid">
  {#if loading}
    <div class="loading">Loading...</div>
  {:else if userType === "customer" && customerCode}
    <CustomerHome {customerCode} {customerName} {customerId} />
  {:else if userType === "oh-user"}
    <OHUserHome />
  {:else}
    <div class="error">
      Invalid user type or missing customer code of: {userType} and customer code of: {customerCode}
    </div>
  {/if}
</div>

<style>
  .app-grid {
    padding: 1rem;
  }

  .loading {
    text-align: center;
    padding: 2rem;
  }

  .error {
    color: red;
    text-align: center;
    padding: 2rem;
  }
</style>
